import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthStateFacade, CustomerStateFacade } from '@zero/shared/util-global-state';
import { BuyingPowerDetails, MultiExanteResponse } from '@zero/shared/util-models';
import { AssetSearchService } from '@zero/shared/util-services';
import { environment } from 'environments/environment';
import { map } from 'rxjs';
import { MultiOrderInstrument } from '../entities/multi-order-instrument';

@Injectable({ providedIn: 'root' })
export class MultiOrderInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #customerStateFacade = inject(CustomerStateFacade);
  readonly #authFacade = inject(AuthStateFacade);
  readonly #assetSearchService = inject(AssetSearchService);
  readonly #api = `${environment.apihost}/api`;
  readonly #apic = `${environment.apihost}/apic`;

  public getMultiOrderConsent() {
    return this.#customerStateFacade.customerBaseData$.pipe(
      map((customerBaseData) => customerBaseData && !customerBaseData.multiOrderConfirmed),
    );
  }

  public confirmMultiOrderConsent() {
    return this.#http.post<void>(`${this.#api}/user/confirmmultiordertrading`, this.#authFacade.customerId);
  }

  public loadBuyingPower() {
    return this.#http.get<BuyingPowerDetails>(`${this.#api}/trading/bpdetails/?customerId=${this.#authFacade.customerId}`);
  }

  public validateMultiOrder(instruments: MultiOrderInstrument[]) {
    return this.#http.post<void>(`${this.#api}/trading/multiorder/validate`, this.#getMultiOrderRequest(instruments));
  }

  public createMultiOrder(instruments: MultiOrderInstrument[]) {
    return this.#http.post<void>(`${this.#api}/trading/multiorder/create`, this.#getMultiOrderRequest(instruments));
  }

  public loadAssets(isins: string[]) {
    return this.#assetSearchService.loadAssetsByIsins(isins);
  }

  public loadExante(isins: string[]) {
    return this.#http.post<MultiExanteResponse>(`${this.#apic}/exante/multi`, {
      customerId: this.#authFacade.customerId,
      isins,
    });
  }

  #getMultiOrderRequest = (instruments: MultiOrderInstrument[]) => ({
    customerId: this.#authFacade.customerId,
    orders: instruments.map(({ isin, qty: quantity, direction }) => ({
      isin,
      quantity,
      direction,
    })),
  });
}
